$('.announcement-slider').slick({
    slidesToShow:1,
    slidesToScroll:1,
    arrows:true,
    dots:false,
    infinite:true,
    autoplay:true,
    autoplaySpeed:5000,
    prevArrow:$('.announcement-prev'),
    nextArrow:$('.announcement-next'),
    adaptiveHeight:false
});

$('.holiday-slider').slick({
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    arrows:true,
    dots:false,
});

$('.customFeatureColl .product-grid').slick({
    infinite:true,
    slidesToShow:6,
    slidesToScroll:1,
    arrows:true,
    dots:false,
    responsive:[
        {
            breakpoint:1591,
            settings:{
                slidesToShow:5
            }
        },
        {
            breakpoint:1199,
            settings:{
                slidesToShow:4
            }
        },
        {
            breakpoint:992,
            settings:{
                slidesToShow:3
            }
        },
        {
            breakpoint:768,
            settings:{
                slidesToShow:2
            }
        },
        {
            breakpoint:575,
            settings:{
                slidesToShow:1
            }
        }
    ]
});

$('.testimonial-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 1000,
    arrows: true,
    dots: false,
    appendArrows: $('.testimonial-arrows'),
    prevArrow: `<button type="button" class="slick-prev"><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="#3D3D3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`,
    nextArrow: `<button type="button" class="slick-next"><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="#3D3D3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`,
    responsive: [
        {
            breakpoint: 1281,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$(document).ready(function () {
    var $carousel = $('.shop-collection-slider');
    $carousel.on('init afterChange', function () {
    // setSlideVisibility();
});
    $carousel.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '60px',
        responsive: [
            {
                breakpoint: 1591,
                settings: {
                    slidesToShow: 4,
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '0px'
                }
            }
        ]
    });
});

$(".tab-container .tab_content").hide();
$(".tab-container").each(function () {
  $(this).find(".tab_content:first").show();
  $(this).find(".tab-dropdown").val($(this).find(".tab_content:first").attr("id"));
});

// Desktop Tabs
$("ul.tabs li").on("click", function () {
  var parent = $(this).closest(".tab-container");

  parent.find(".tab_content").hide();

  var activeTab = $(this).attr("rel");
  parent.find("#" + activeTab).fadeIn();

  parent.find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  // Sync dropdown
  parent.find(".tab-dropdown").val(activeTab);

  $(".product-list").slick("refresh");
});

// Mobile Dropdown
$(".tab-dropdown").on("change", function () {
  var parent = $(this).closest(".tab-container");
  var activeTab = $(this).val();

  parent.find(".tab_content").hide();
  parent.find("#" + activeTab).fadeIn();

  // Sync desktop tabs
  parent.find("ul.tabs li").removeClass("active");
  parent.find("ul.tabs li[rel='" + activeTab + "']").addClass("active");

  $(".product-list").slick("refresh");
});

document.addEventListener("DOMContentLoaded", function () {
  const browseBy = document.getElementById("BrowseBy");

  if (browseBy) {
    browseBy.addEventListener("change", function () {
      window.location.href = this.value;
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector(
    '.template-product .product-form .shopify-payment-button'
  );

  if (!container) return;

  const showButton = () => {
    const button = container.querySelector('shop-pay-wallet-button');

    if (button) {
      button.style.setProperty('display', 'block', 'important');
    }
  };

  showButton();

  const observer = new MutationObserver(showButton);

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden']
  });
});




